import { useTableState } from '@driftt/dds'
import { pathOr } from 'ramda'
import { useMemo } from 'react'
import { useQuery } from 'react-query'

import {
  getScenariosTableData,
  Scenario,
  ScenariosTableQueryParams,
  ScenariosTableResponse,
} from 'api/scenarios'
import { GUARDRAILS_NAMES } from 'constants/scenarios'

export const useScenariosList = ({
  nameQuery = '',
  sortProperty = 'updated_at',
  sortDirection = 'desc',
  status = 'ENABLED',
  archived = false,
  page = 0,
  pageSize = 10,
  orgId = '',
}: ScenariosTableQueryParams) => {
  const { tableState, handleTableStateChange } = useTableState<Scenario>({
    defaultPagination: {
      pageIndex: page,
      pageSize,
    },
  })

  const {
    isLoading,
    data: scenariosListData,
    refetch: refetchTableState,
  } = useQuery({
    queryKey: [
      `scenarios-list--all-${orgId}-${tableState.pagination.pageIndex}-${tableState.pagination.pageSize}-${status}`,
      nameQuery,
    ],
    queryFn: () =>
      getScenariosTableData({
        // nameQuery,
        // sortDirection,
        // sortProperty,
        archived,
        page: tableState.pagination.pageIndex + 1,
        pageSize: tableState.pagination.pageSize,
        orgId,
      }),
    select: ({ data }) => data,
    refetchOnWindowFocus: false,
    cacheTime: Infinity,
    staleTime: Infinity,
    retry: false,
  })

  const memoizedScenarios = useMemo<Scenario[]>(() => {
    const scenariosPageRows = pathOr(
      [] as ScenariosTableResponse['scenariosPageRows'],
      ['scenariosPageRows'],
      scenariosListData
    )

    return scenariosPageRows.filter((item) => {
      return item.name && !GUARDRAILS_NAMES.includes(item.name)
    })
  }, [scenariosListData])

  const memoizedRowTotal = useMemo(
    () => pathOr(0, ['meta', 'total'], scenariosListData),
    [scenariosListData]
  )

  const totalPages = useMemo(
    () => pathOr(0, ['meta', 'totalPages'], scenariosListData),
    [scenariosListData]
  )

  return {
    isLoading,
    scenarios: memoizedScenarios,
    handleTableStateChange,
    pagination: {
      ...tableState.pagination,
      totalPages,
    },
    rowTotal: memoizedRowTotal,
    refetchTableState,
  }
}
